<!-- <div class="textbox-container">
    <label for="textbox" style="font-weight:normal;" [hidden]="!label">{{label}}</label>
    <input type="text" id="textbox" name="textbox"/>
</div> -->

@if (readonly) {
<div class="floating-label-container">
    <div style="position:relative; border:1px solid #dddddd;  border-radius: 4px; padding:0px;">
    @if (this.type == TextModes.CurrencyUSD) {
        <div class="leftOverlay">$</div>
    }
    @if (this.type == TextModes.Percent) {
        <div class="rightOverlay">%</div>
    }
    @if (this.type != TextModes.Password) {
        <input type="text"  style="padding:7px 0px 7px 7px;" [disabled]="true" [class]="this.type == TextModes.CurrencyUSD || this.type == TextModes.Percent ? 'floatTextExtraPadding' : ''" [(ngModel)]="boundValue" [style.width.%]="control_width_pct" [style.width.px]="control_width_px" />
    }
    @if (this.type == TextModes.Password) {
        <input type="password" [disabled]="true" [(ngModel)]="boundValue" [style]="style" [style.width.%]="control_width_pct" [style.width.px]="control_width_px" />
    }
    </div>
    <div class="floatLabel">{{label}}</div>
</div>
}
  
<div class="form-input-container" [style]="style">
  
    @if (!readonly) {
        <label>{{label}}</label>

        <!-- TODO: padding-left should be conditional based on whether there's left overlay or right overlay -->
        <div style="position:relative;">
            <div style="position:relative; align-items: center;">
                @if (this.type == TextModes.CurrencyUSD || this.type == TextModes.Percent) {
                    @if (this.type == TextModes.CurrencyUSD) {
                        <div class="leftOverlay">$</div>
                        <input type="text" style="padding-left:17px;" [value]="defaultText" [placeholder]="hint" [disabled]="disabled" [class.is-invalid]="!isValid" class="form-input" [attr.tid]="testId" id="{{myId}}" #textbox [(ngModel)]="boundValue" (keyup)="_handle_onKeyUp($event)" [style.width.%]="control_width_pct" [style.width.px]="control_width_px" (blur)="handle_onBlur($event)" />
                    }
                    @if (this.type == TextModes.Percent) {
                        <div class="rightOverlay">%</div>
                        <input type="text" [value]="defaultText" [placeholder]="hint" [disabled]="disabled" [class.is-invalid]="!isValid" class="form-input" [attr.tid]="testId" id="{{myId}}" #textbox [(ngModel)]="boundValue" (keyup)="_handle_onKeyUp($event)" [style.width.%]="control_width_pct" [style.width.px]="control_width_px" (blur)="handle_onBlur($event)" />
                    }
                }
                @else {
                <!-- <div *ngIf="hint && hint != ''" class="rightOverlay" style="font-size:.9em; color:#777777; font-style: italic;">&nbsp;{{hint}}</div> -->
                    @if (this.type != TextModes.Password) {
                        <!--add a conditional class-->
                        <input type="text" [value]="defaultText" [placeholder]="hint" [disabled]="disabled" [class.is-invalid]="!isValid" class="form-input floatText" [attr.tid]="testId" id="{{myId}}" #textbox [(ngModel)]="boundValue" (keyup)="_handle_onKeyUp($event)" [style.width.%]="control_width_pct" [style.width.px]="control_width_px" (blur)="handle_onBlur($event)" />
                    }
                    @if (this.type == TextModes.Password) {
                        <input type="password" class="floatText"  [attr.tid]="testId" id="{{myId}}" #textbox [(ngModel)]="boundValue" (keyup)="_handle_onKeyUp($event)" [style]="style" [style.width.%]="control_width_pct" [style.width.px]="control_width_px" (blur)="handle_onBlur($event)" />
                    }
                }
            </div>
            <div class="validation-msg" [hidden]="isValid">{{validationMsg}}</div>
        </div>
        <!-- @if (helpText != '') {
        <mat-icon class="iconOverlay" matTooltip="{{helpText}}" [ngStyle]="{'color':'#6b7475'}">info</mat-icon>
        } -->
    }
    <!-- @if (this.type == TextModes.CurrencyUSD) {
      <div style="margin-top:-10px; font-size:.9em; color:#777777; font-style: italic;">USD</div>
    } -->
  
</div>